module.exports = __webpack_public_path__ + "media/images/instruction/step-two-f498f41bf06151ca995b46bf54336a41.svg";